__turbopack_context__.v({
  "backdrop": "LoginBonusWindow-module__7X6JwW__backdrop",
  "card": "LoginBonusWindow-module__7X6JwW__card",
  "cols": "LoginBonusWindow-module__7X6JwW__cols",
  "day": "LoginBonusWindow-module__7X6JwW__day",
  "error": "LoginBonusWindow-module__7X6JwW__error",
  "eyebrow": "LoginBonusWindow-module__7X6JwW__eyebrow",
  "got": "LoginBonusWindow-module__7X6JwW__got",
  "gotList": "LoginBonusWindow-module__7X6JwW__gotList",
  "head": "LoginBonusWindow-module__7X6JwW__head",
  "hole": "LoginBonusWindow-module__7X6JwW__hole",
  "later": "LoginBonusWindow-module__7X6JwW__later",
  "leather": "LoginBonusWindow-module__7X6JwW__leather",
  "none": "LoginBonusWindow-module__7X6JwW__none",
  "press": "LoginBonusWindow-module__7X6JwW__press",
  "reward": "LoginBonusWindow-module__7X6JwW__reward",
  "rise": "LoginBonusWindow-module__7X6JwW__rise",
  "row": "LoginBonusWindow-module__7X6JwW__row",
  "what": "LoginBonusWindow-module__7X6JwW__what",
  "window": "LoginBonusWindow-module__7X6JwW__window",
});
